/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState } from 'react'
import S3UploadHook from '../../CommonMethods/S3UploadHook'
import ErrorMessage from '../ErrorMessage'
import ToolTip from '../ToolTip'
import { ColorRing } from 'react-loader-spinner'
import { useDispatch, useSelector } from 'react-redux'
import { updateState } from '../../pages/ManageMerchants/components/Customization/CutomizationSlice'
// import UploadProgress from '../UploadProgress'
// import { pushOrRemoveElement } from '../../CommonMethods/pushOrRemoveElement'

export default function FileUploadInput({
    state,
    id,
    formatError,
    setState,
    setformatError,
    setimageLoading,
    imageLoading,
    s3Prefix,
    newState,


}) {
    const imageTypes = ['image/png', 'image/jpeg', 'image/jpg']
    const [progressCount, setprogressCount] = useState(0)
    const [showOverlay, setShowOverlay] = useState(false)
    const [error, setError] = useState('')
    const custom_variable = useSelector(state => state.customization)
    const { custom } = custom_variable;
    const dispatch = useDispatch()
    const CDNurl = import.meta.env.VITE_CDN_URL;
    //Upload file
    // async function handleUploadChange(e) {
    //     setformatError('')
    //     const path = `${mainKey}/${e.target.id}`
    //     const selectedFile = e.target.files[0];
    //     setimageLoading(e.target.id)
    //     if (e.target.files) {
    //         if (!imageTypes.includes(e.target.files[0].type) || (selectedFile && selectedFile.size > 10 * 1024 * 1024)) {
    //             // setOpen('')
    //             // const errorElement = pushOrRemoveElement(formatError, e.target.id)
    //             setformatError(e.target.id);
    //             setimageLoading('')

    //             // return

    //         } else {
    //             // setloading('upload')
    //             const file = e.target.files[0];
    //             const fileLink = URL.createObjectURL(file);
    //             let url = ''
    //             if (file.name && file.type) {
    //                 url = await S3UploadHook(file, `${mainKey}/${id}`, setprogressCount);

    //                 const val = `${mainKey}/${id}/${file.name}`

    //                 setstate((prv) => ({
    //                     ...prv,
    //                     [id]: url
    //                 }))
    //                 setimageLoading('')

    //                 return
    //                 // handleSubmit(file,fileLink)
    //             }
    //         }

    //     }

    // }


    async function handleUploadChange(e) {
        setimageLoading(true);
        setError('')
        let file = e.target.files[0];

        //check for file type
        if (!imageTypes.includes(file.type)) {
            setError('Please upload a PNG, JPEG, or JPG image.');
            setimageLoading(false);
            e.target.value = null;
            return;
        }
        // Check for file size (5MB limit)
        const maxSize = 5 * 1024 * 1024; // 5MB in bytes
        console.log(file.size,'filleeee')
        console.log(maxSize,'max')
        if (file.size > maxSize) {
            setError('File size should not exceed 5MB.');
            setimageLoading(false);
            e.target.value = null;
            return;
        }
        setimageLoading(true);
        let url = ''

        if (file.name && file.type) {
            url = await S3UploadHook(file, `${s3Prefix}`, setprogressCount);
            url = 'public/' + url
        }
        setState((prv) => ({
            ...prv,
            ['store_logo']: url,
        }))
        dispatch(updateState({'store_logo' : url}))
        setimageLoading(false)
        e.target.value = null;
    }
    //remove file
    const handleRemove = (key) => {
        setState((prv) => ({
            ...prv,
            [key]: ''
        }))
        dispatch(updateState({'store_logo' : ''}))
        setShowOverlay(false);
    }

    const handleMouseEnter = () => {
        setShowOverlay(true);
    };

    const handleMouseLeave = () => {
        setShowOverlay(false);
    };
    return (
        <>
            {newState?.custom_store_theme ? (state['store_logo'] === '' ?
                (<div className='relative w-fit cursor-pointer mb-3' >
                    {/* <div className='py-2 pl-[19px] pr-[9px] w-fit rounded-[12px] border cursor-pointer border-[#9E2064]'>
                <p></p>
            </div> */}
                    <input
                        type="file"
                        id='fileUpload'
                        className="absolute w-full h-full top-0 left-0 rounded-[12px] cursor-pointer"
                        style={{ display: 'none' }}
                        accept="image/jpeg, image/png"
                        onChange={(e) => handleUploadChange(e)}
                    />
                    <label htmlFor="fileUpload" className='py-2 pl-[19px] pr-[19px] h-[34px] w-[130px] rounded-[12px] flex justify-center items-center border cursor-pointer border-[#9E2064]'>
                        {imageLoading ?
                            <ColorRing
                                visible={true}
                                height="25"
                                width="25"
                                ariaLabel="blocks-loading"
                                wrapperStyle={{}}
                                wrapperClass="blocks-wrapper"
                                colors={['#9E2064', '#9E2064', '#9E2064', '#9E2064', '#9E2064']}
                            /> :
                            (<div className='flex'><p className='text-[#9E2064] font-normal text-xs mr-2'>Upload image</p>
                                <img src="/assets/images/upload.svg" alt="upload-svg" /></div>)}

                    </label>
                    <p className='text-xs mt-2 font-normal text-[#1F1F1F]'>File size: Upto 5MB</p>
                    {error !== '' && <p className='text-xs font-normal text-[#F04438] pt-1.5'>{error}</p>}
                </div>) :
                <div className='w-fit relative' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} data-testid="image-hover">
                    <img
                        src={`${CDNurl}${state.store_logo}`}
                        alt=""
                        data-testid="image-hover"
                        className='w-[125px] h-[125px] object-contain'
                        onMouseEnter={() => setShowOverlay(true)}
                        onMouseLeave={() => setShowOverlay(false)}

                    />
                    {showOverlay && <div
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        data-testid="image-hover"
                        className='absolute w-full h-full top-0 bg-slate-300 opacity-50  left-0 flex items-center justify-center'

                    >
                        <img src="/assets/images/x-circle.svg" alt="close-icon" loading='lazy' onClick={() => handleRemove('store_logo')} data-testid="x-btn" />
                    </div>}
                </div>) :
                (
                    <div className='w-fit relative pb-2'>
                        <img
                            src={`/assets/images/store.svg`}
                            alt=""
                            className='w-[125px] h-[125px] object-cover cursor-default border border-[#EB9DC7]'
                        />
                    </div>
                )}
        </>
    )
}
